import { PkTheme } from '@shared-types/common.types';

/**
 * Get the Panenka theme of the element
 * @param element The element to get the theme from
 * @returns PkTheme
 */
export const getElementPkTheme = (element: Element): PkTheme => {
  const closestEl = element?.closest('[pk-theme],[class*="pk-theme--"]');

  if (!closestEl) return PkTheme.LIGHT;

  const themeAttr = closestEl.getAttribute('pk-theme');
  const themeClass = /pk-theme--(light|dark)/.exec(closestEl.className)?.[1];
  if (![PkTheme.LIGHT, PkTheme.DARK].includes(themeAttr) && ![PkTheme.LIGHT, PkTheme.DARK].includes(themeClass)) {
    return getElementPkTheme(closestEl.parentElement);
  }

  const isDark = themeAttr === PkTheme.DARK || themeClass === PkTheme.DARK;

  return isDark ? PkTheme.DARK : PkTheme.LIGHT;
};
